import { Directive, ElementRef, HostListener, SimpleChanges, OnChanges, AfterViewInit } from '@angular/core';
import { setTimeout } from 'timers';

@Directive({
  selector: 'textarea[autosize]'
})
export class AutosizeDirective implements AfterViewInit {
  constructor(public element: ElementRef) {

  }

  @HostListener('input', ['$event.target'])
  public onInput() {
    this.resize();
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      this.resize();
    },  500);
  }

  @HostListener('window:resize', ['$event.target'])
  public onResize(textArea: HTMLTextAreaElement): void {
    this.resize();
  }

  public resize() {
    const style = this.element.nativeElement.style;
    style.overflow = 'hidden';
    style.height = 'auto';

    const height = this.element.nativeElement.scrollHeight;
    style.height = `${height}px`;
  }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/autosize/autosize.directive.ts